// Changes not yet saved: leaving the page asks first, in the app and when the tab closes.
import { useEffect } from 'react';
import { useBlocker } from 'react-router';
import { useConfirm } from '../Sheet';

export function useUnsavedChanges(dirty: boolean, what = 'your changes'): void {
  const ask = useConfirm();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname,
  );
  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }
    void ask({
      title: 'Leave without saving?',
      message: `If you leave now, ${what} are lost.`,
      confirm: 'Leave',
      cancel: 'Stay',
    }).then((leave) => (leave ? blocker.proceed() : blocker.reset()));
  }, [blocker, ask, what]);
  useEffect(() => {
    if (!dirty) {
      return;
    }
    const warn = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
}
